import http from './httpService';
import config from './../config.json';



export const getCustomerGroup = (adminName) => {
    return http.get(config.server_address + '/groups/' + adminName);
}
export const getCustomerArchive = (params) => {
    return http.get(config.server_address + '/getArchive', { params });
}
export const insertCustomer = (info) => {
    return http.post(config.server_address + '/addUser/iammahdi', info);
}
export const getLicense = (info) => {
    return http.post(config.server_address + '/license', info);
}
export const updateLicense = (info) => {
    return http.post(config.server_address + '/update-license', info);
}
export const updateInfo = (info) => {
    return http.post(config.server_address + '/update-info', info);
}
export const updateSmsInfo = (info) => {
    return http.post(config.server_address + '/update-sms-info', info);
}
export const updatePayment = (info) => {
    return http.post(config.server_address + '/update-payment', info);
}
export const deleteCustomer = (cName) => {
    return http.delete(config.server_address + '/deleteUser/iammahdi/' + cName);
}